import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FilterPipe } from '../../pipes/filter.pipe';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';
import { FilterCatalogPipe } from '../../pipes/filter-catalog.pipe';
import { SubFormDirective } from 'src/app/directives/sub-form-directive';

@NgModule({
  declarations: [FilterPipe, SafeHtmlPipe, FilterCatalogPipe, SubFormDirective],
  imports: [
    CommonModule
  ],
  exports: [FilterPipe, SafeHtmlPipe, FilterCatalogPipe, SubFormDirective]
})
export class SharedModule { }
